import { SetSystemFlags } from '@protector/entities/core/__legacy__/redux.actions';
import { ROLLOUT_KEY } from 'config/constants';
import { getSelectedCompanyId } from 'core/core.selectors';
import { getUserId } from 'entities/user/user.selectors';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Rox from 'rox-browser';

type FeatureFlags = Record<string, Rox.Flag | Rox.RoxString | Rox.RoxNumber>;

export const featureFlags: FeatureFlags = {
  P40_64528_enable_operation_date_time_edit: new Rox.Flag(false),
  P40_34127_disease_risk_potato: new Rox.Flag(false),
  P40_34223_disease_risk_potato_mock: new Rox.Flag(false),
  P40_34565_disease_risk_pre_season: new Rox.Flag(false),
  trapTaskTypeList: new Rox.RoxString(''),
  limitOfTasks: new Rox.RoxString('{"able": true, "limit": 300, "minutes": 30}'),
  AreasWithoutGeometryFlags: new Rox.RoxString(''),
  CompaniesWithDetailedConsolidatedFlags: new Rox.RoxString(''),
  P40_43662_hideRegionSummary: new Rox.Flag(),
  P40_21430_scoutingScoreXray: new Rox.Flag(),
  P40_22961_change_api_imagery: new Rox.RoxString(''),
  P40_22530_companies_with_field_book: new Rox.RoxString(''),
  P40_24588_enableMultiplePhotosNotes: new Rox.Flag(),
  P40_24324_scouting_score_setup: new Rox.Flag(),
  P40_24023_notes_module: new Rox.Flag(),
  P40_61669_reports_mfe_preview: new Rox.Flag(false),
  P40_63012_static_points_date_range: new Rox.Flag(false),
  P40_62783_visit_dashboard_preview: new Rox.Flag(false),
  P40_62870_scoped_reports_endpoint: new Rox.Flag(false),
  P40_62788_c_level_technician_kpi_modal: new Rox.Flag(false),
  P40_62789_c_level_date_range_shortcuts: new Rox.Flag(false),
  P40_62528_hide_inventory_report: new Rox.Flag(false),
  P40_62477_ai_chatbot: new Rox.Flag(false),
  P40_25084_splitRequestDaysIndicators: new Rox.Flag(),
  P40_25127_spain_mvp_custom_field: new Rox.RoxString(''),
  P40_26233_notes_midia_viewer: new Rox.Flag(),
  P40_26233_notes_products_available: new Rox.RoxString(''),
  P40_53913_maximumAreasByClusterString: new Rox.RoxString('800'),
  post_harvest_enable_only_admin_strider: new Rox.Flag(),
  leafhopper_enable_only_admin_strider: new Rox.Flag(),
  P40_27679_new_api_trapview_integration: new Rox.Flag(),
  P40_28469_leafhopper_plan: new Rox.Flag(),
  P40_29177_show_modal_layout_edit_heatmap: new Rox.Flag(),
  P40_29700_show_statistic_legend: new Rox.Flag(),
  P40_29585_integrate_web_panel_with_RBAC: new Rox.Flag(),
  P40_30249_clusteringInputLeafhopper: new Rox.Flag(),
  P40_34903_disease_risk_batch: new Rox.Flag(false),
  P40_31096_trendGraphOnXRay: new Rox.Flag(),
  P40_27952_c_level_report: new Rox.Flag(),
  P40_31566_GET_LAST_CONTRACT_HEADER: new Rox.Flag(),
  P40_324292_new_property_methodology_endpoint: new Rox.Flag(),
  P40_33267_report_button_in_hall_of_properties: new Rox.Flag(),
  P40_33943_product_status: new Rox.Flag(),
  P40_33921_FILTER_UNIQUE_PRODUCTS: new Rox.Flag(),
  P40_34609_LEAFHOPPER_PHENOMENA_IDS: new Rox.RoxString('[]'),
  P40_34609_LEAFHOPPER_SCOUTING_MAP_BY_TEAMS: new Rox.Flag(),
  P40_34332_GROUP_CUSTOM_FIELDS: new Rox.Flag(),
  P40_34839_DISABLE_NEW_SEASON_FIELD_TO_METHODOLOGY: new Rox.Flag(),
  P40_34466_CHANGE_DATE_RANGE_TO_TABLE_MODE: new Rox.Flag(),
  P40_34493_USE_AREA_TABLE_ROWS: new Rox.Flag(false),
  CWS_10071_OKTA_LOGOUT: new Rox.Flag(false),
  P40_36273_disable_clustering: new Rox.Flag(true),
  P40_36320_trackings_by_segment: new Rox.Flag(false),
  P40_37190_filter_regions_by_current_season_area: new Rox.Flag(false),
  P40_37779_dr_potato_split_today: new Rox.Flag(false),
  P40_37022_dr_potato_model_update_timestamp: new Rox.Flag(false),
  P40_37413_DISEASE_RISK_WEATHER_STATION: new Rox.Flag(true),
  P40_37906_check_if_product_is_available_in_warehouse_stock: new Rox.Flag(),
  P40_38006_LOAD_PRODUCTS_PARALLEL: new Rox.Flag(false),
  P40_37709_rea_integration_hall_of_properties: new Rox.Flag(false),
  P40_38695_centralize_fields_tasks: new Rox.Flag(false),
  P40_38847_download_button_field_book_spain: new Rox.Flag(false),
  P40_39027_dr_field_config_v2: new Rox.Flag(false),
  P40_40181_dr_field_functional_multi_crops: new Rox.Flag(false),
  P40_38920_check_permission_for_edit_field: new Rox.Flag(false),
  P40_39085_field_cluster_selector_modal: new Rox.Flag(false),
  P40_39_39399_filter_stations_by_last_event_date: new Rox.Flag(false),
  P40_41514_split_current_info: new Rox.Flag(false),
  P40_39836_pest_risk_in_leafhopper_plan: new Rox.Flag(false),
  P40_40736_enable_configure_cif: new Rox.Flag(false),
  P40_27952_c_level_report_by_userID: new Rox.RoxString(''),
  P40_41327_enable_product_warnings: new Rox.Flag(false),
  P40_41626_enable_product_tasks_details: new Rox.Flag(false),
  P40_40974_enable_product_details_mfe: new Rox.Flag(false),
  P40_27952_c_level_report_by_companyID: new Rox.Flag(false),
  P40_42449_c_level_report_widget_KPI: new Rox.Flag(false),
  P40_42449_c_level_report_BBCH: new Rox.Flag(false),
  overview_report_limit_date: new Rox.RoxNumber(7),
  P40_43985_c_level_page_size: new Rox.RoxNumber(1),
  c_level_report_page_size_kpis: new Rox.RoxNumber(1),
  c_level_report_page_size_bbch: new Rox.RoxNumber(1),
  P40_44078_blocked_fields_report: new Rox.Flag(false),
  P40_43874_showing_the_evolution_graph_without_normalize_data: new Rox.Flag(false),
  P40_44286_REGION_TREE_SELECT_ANTD_V5: new Rox.Flag(false),
  P40_44838_DATADOG_RUM: new Rox.Flag(false),
  P40_44838_DATADOG_CONFIG: new Rox.RoxString(''),
  P40_44342_interoperability_balance_protector: new Rox.Flag(false),
  control_strategies_orgs_allowlist: new Rox.RoxString('[]'),
  c_level_report_drawer_subscriber_show_all_channels_list: new Rox.RoxString('[]'),
  P40_35244_GET_TRAPS_FROM_ALL_PERIOD: new Rox.Flag(false),
  P40_45298_SHOW_POPOVER_WHEN_FILTER_TRAPS_FROM_ALL_PERIOD: new Rox.Flag(false),
  P40_45434_SEASON_REPORT: new Rox.Flag(false),
  P40_45546_HIDE_INTEGRATIONS_OPTION: new Rox.Flag(false),
  P40_45783_NEW_WAREHOUSES_COMPANY_MOVEMENTS: new Rox.Flag(false),
  P40_45293_use_new_hall_of_companies_mfe: new Rox.Flag(false),
  P40_45293_hall_of_companies_mfe_by_country: new Rox.RoxString('[]'),
  P40_45293_hall_of_companies_mfe_by_workspace_id: new Rox.RoxString('[]'),
  P40_45293_hall_of_companies_mfe_by_job_title: new Rox.RoxString('[]'),
  P40_45293_hall_of_companies_mfe_by_user: new Rox.RoxString('[]'),
  P40_46597_showing_the_platings_section: new Rox.Flag(false),
  balance_empty_state_redirect_link: new Rox.RoxString('mailto:suporte.digital@syngenta.com'),
  P40_45293_hall_of_companies_mfe_black_list_by_userid: new Rox.RoxString('[]'),
  P40_48280_filter_as_false_by_plan: new Rox.RoxString('[]'),
  P40_48280_filter_as_false_by_workspace_id: new Rox.RoxString('[]'),
  P40_48231_map_with_locations: new Rox.Flag(false),
  P40_48974_new_hall_of_companies_auto_redirect_property: new Rox.Flag(false),
  P40_48625_use_new_image_url_to_crops: new Rox.Flag(false),
  P40_49321_SOURCE_COMPONENT: new Rox.Flag(false),
  P40_47231_show_seeds_irrigation_fields: new Rox.Flag(false),
  P40_49329_IMAGERY_EXPLORER_BRAND_UPDATE: new Rox.Flag(false),
  P40_49783_REMOVE_REVERSE_LONG_LAT: new Rox.Flag(false),
  P40_49135_DIGITAL_TRAPS_MANAGEMENT: new Rox.Flag(false),
  P40_50094_showing_the_harvesting_section: new Rox.Flag(false),
  P40_50705_SUBSCRIPTION_MANAGEMENT: new Rox.Flag(false),
  P40_50648_order_phenomenon_found_by_userid: new Rox.RoxString('[]'),
  P40_50648_order_phenomenon_found_by_orgId: new Rox.RoxString('[]'),
  P40_50521_enable_ai_insights_on_notes: new Rox.Flag(false),
  P40_50521_enable_ai_insights_by_user_id: new Rox.RoxString('[]'),
  P40_50648_order_phenomenon_found_by_order: new Rox.Flag(false),
  P40_50523_enable_ai_insights_on_x_ray: new Rox.Flag(false),
  P40_51214_VORONOI_MAP: new Rox.Flag(false),
  P40_51214_ISOHYET_MAP: new Rox.Flag(false),
  P40_50523_enable_ai_insights_on_management_overview: new Rox.Flag(false),
  P40_51797_REDIRECT_TO_BALANCE: new Rox.Flag(false),
  P40_50648_order_phenomenon_found_by_custom: new Rox.Flag(false),
  P40_51837_PHENOMENON_SELECTION_IN_TIMELINE_LAYER: new Rox.Flag(false),
  P40_51793_search_methodology_list: new Rox.Flag(false),
  P40_52910_sort_methodology_list: new Rox.Flag(false),
  P40_51792_sort_methodology_indicators: new Rox.Flag(false),
  P40_51694_EXPORT__POWER_BI_REPORT: new Rox.Flag(false),
  P40_51794_SHOW_PLUVIOMETERS_WITHOUT_REPRESENTED_AREA: new Rox.Flag(false),
  P40_52409_SELECT_CONTROL_STRATEGY_BY_CLUSTER: new Rox.Flag(false),
  P40_52358_enable_modal_no_seasons: new Rox.Flag(false),
  P40_52048_enable_ai_insights_products_targets_insights: new Rox.Flag(false),
  P40_53000_render_pluviometer_trap: new Rox.Flag(false),
  P40_53247_regional_risk_tabs: new Rox.Flag(false),
  P40_53695_flowering_supplemental_pollination: new Rox.Flag(false),
  P40_53248_disease_risk_new_notes_drawer: new Rox.Flag(false),
  P40_62023_digital_traps_network_notes_drawer: new Rox.Flag(false),
  P40_62993_regional_risk_activity_button: new Rox.Flag(false),
  CWS_20146_AG_OPERATION_PRESCRIPTION_ENABLED: new Rox.Flag(false),
  CWS_20146_AG_OPERATION_SPRAYING_ENABLED: new Rox.Flag(false),
  CWS_20146_AG_OPERATION_CUSTOM_INPUTS_ENABLED: new Rox.Flag(false),
  P40_53178_TRANSLATE_OPERATION_SCHEMA: new Rox.Flag(false),
  P40_54858_enable_trend_report: new Rox.Flag(false),
  P40_54240_enable_overview_points_popup: new Rox.Flag(false),
  P40_55109_filter_deleted_products: new Rox.Flag(false),
  P40_54678_enable_conditional_toggle_fields: new Rox.Flag(false),
  P40_54863_hide_sidebar_menu_in_mobile: new Rox.Flag(false),
  P40_54871_enable_report_button_for_mobile: new Rox.Flag(false),
  P40_55568_enable_notes_exportable_report: new Rox.Flag(false),
  P40_55878_ENABLE_NOTE_TRANSCRIPTION: new Rox.Flag(false),
  P40_55174_regional_overview_shift_alert: new Rox.Flag(false),
  P40_56036_enable_ai_insights_on_season_report: new Rox.Flag(false),
  P40_56610_enable_select_products_in_days_without_spray_layer: new Rox.Flag(false),
  P40_61863_enable_times_applied_products_layer: new Rox.Flag(false),
  P40_62104_enable_product_groups_sorting: new Rox.Flag(false),
  P40_62214_enable_last_spray_in_spray_drawer: new Rox.Flag(false),
  P40_47409_enable_online_report: new Rox.Flag(false),
  P40_62576_enable_ag_operation_report: new Rox.Flag(false),
  P40_56666_enable_flaming_operation_type: new Rox.Flag(false),
  P40_57972_enable_emergence_timeline: new Rox.Flag(false),
  P40_57179_reentry_rate_uom_on_xray: new Rox.Flag(false),
  P40_56734_enable_fields_grouped_by_risk_level_risk_management: new Rox.Flag(false),
  P40_57292_auto_zero_inference: new Rox.Flag(false),
  P40_57819_edit_field_cluster: new Rox.Flag(false),
  P40_57834_track_decisions: new Rox.Flag(false),
  P40_54652_enable_ai_insights_user_request: new Rox.Flag(false),
  P40_57054_enable_filter_actions_in_timeline: new Rox.Flag(false),
  P40_57834_track_decisions_by_orgId: new Rox.RoxString('[]'),
  P40_59422_track_decision_exit_disabled_by_orgId: new Rox.RoxString('[]'),
  P40_58392_dr_cereals_config: new Rox.Flag(false),
  P40_54652_enable_ai_insights_display_graphs: new Rox.Flag(false),
  P40_58849_enable_direct_pdf_download: new Rox.Flag(false),
  P40_59777_enable_pdf_preview_modal: new Rox.Flag(false),
  NEMA_1320_show_nema_map_view_mfe: new Rox.Flag(false),
  NEMA_1276_show_nema_workspace_map_view_mfe: new Rox.Flag(false),
  NEMA_1432_enable_pptx_report: new Rox.Flag(false),
  P40_59547_multi_property_trap_report: new Rox.Flag(false),
  P40_59547_enable_multi_property_trap_report_for_sugarcane: new Rox.Flag(false),
  P40_59949_include_archived_fields: new Rox.Flag(false),
  P40_59944_MONITORING_TASK_FILE_UPLOAD: new Rox.Flag(false),
  P40_59420_monitoring_found_occurrences_rules: new Rox.Flag(false),
  P40_59422_dashboard_track_decision: new Rox.Flag(false),
  P40_61251_treatment_efficacy: new Rox.Flag(false),
  P40_61561_trap_installation_status_filter: new Rox.Flag(false),
  P40_61408_use_fields_by_seasons_endpoint: new Rox.Flag(false),
  P40_62642_use_fields_by_seasons_cache: new Rox.Flag(true),
  P40_55441_measures_via_observation_service: new Rox.Flag(false),
  P40_61940_pest_management_submenu: new Rox.Flag(false),
  P40_59224_indicator_values_on_map: new Rox.Flag(false),
  P40_62627_blocking_reason_filter_by_user: new Rox.RoxString('[]'),
  P40_63528_traps_monitoring_results_concurrency: new Rox.RoxNumber(1),
  P40_62788_hide_property_dashboard: new Rox.Flag(false),
  P40_63187_infestation_season_control_strategy_filter: new Rox.Flag(false),
  P40_64622_control_strategy_priority: new Rox.Flag(false),
  P40_64677_post_application_triggers: new Rox.Flag(false),
  P40_61804_risk_parameter_filter: new Rox.Flag(false),
  P40_63680_agops_mfe: new Rox.Flag(false),
  P40_64527_render_trap_info_on_timeline: new Rox.Flag(false),
  P40_64914_render_rain_gauge_info_on_timeline: new Rox.Flag(false),
  P40_64214_enable_monitoring_comments: new Rox.Flag(false),
  P40_64319_routing_configuration_v2: new Rox.Flag(false),
  P40_64908_routing_plan_name_editing: new Rox.Flag(false),
  P40_64190_fix_shared_routes_levels: new Rox.Flag(true),
  P40_64308_edit_field_mfe: new Rox.Flag(false),
  P40_64533_enable_field_details: new Rox.Flag(false),
  P40_65019_manual_traps_entry_point: new Rox.Flag(false),
  P40_65328_manual_traps_add_counts: new Rox.Flag(false)
};

type SystemFlags = Record<string, string | number | boolean>;

const mapSystemFeatureFlags = () => {
  const systemFlags: SystemFlags = {};

  Object.keys(featureFlags).forEach(flag => {
    const roxFlag = featureFlags[flag];

    if (
      (roxFlag as unknown as Record<'_type', string>)._type === 'string' ||
      (roxFlag as unknown as Record<'_type', string>)._type === 'number'
    ) {
      systemFlags[flag] = (roxFlag as Rox.RoxString).getValue();
    } else {
      systemFlags[flag] = (roxFlag as Rox.Flag).isEnabled();
    }
  });

  return systemFlags;
};

export const applyPlaywrightFeatureFlagOverrides = () => {
  if (!import.meta.env.DEV || !globalThis.__playwright || !globalThis.__roxOverrides) {
    return;
  }
  Object.entries(globalThis.__roxOverrides).forEach(([flagName, value]) => {
    Rox.overrides.setOverride(flagName, value);
  });
};

/**
 * E2E: signal that redux SystemFlags now mirror Rollout so Playwright specs can await readiness
 * instead of racing Rollout's async network setup before a flag-dependent fetch. DEV + __playwright only.
 */
export const signalFeatureFlagsReadyForPlaywright = () => {
  if (!import.meta.env.DEV || !globalThis.__playwright) {
    return;
  }
  globalThis.__featureFlagsReady = true;
};

const useLoadFeatureFlags = () => {
  const [rolloutLoaded, setRolloutLoaded] = useState(false);
  const { companyId, propertyId } = useParams();
  const selectedCompanyId = useSelector(getSelectedCompanyId);
  const userId = useSelector(getUserId);
  const dispatch = useDispatch();

  const onRoxReady = () => {
    setRolloutLoaded(true);
  };

  const initRollout = useCallback(async () => {
    if (!Rox.flags.length) {
      Rox.register('', featureFlags);
    }
    applyPlaywrightFeatureFlagOverrides();
    await Rox.setup(ROLLOUT_KEY ?? '', {
      configurationFetchedHandler: onRoxReady
    });
  }, []);

  useEffect(() => {
    void initRollout();
  }, [initRollout]);

  useEffect(() => {
    if (!rolloutLoaded) {
      return;
    }
    // Dispatch as soon as Rollout resolves so routes that gate on `systemFlags` (e.g.
    // the disease-risk shell) do not stay blank while the user id is still being
    // loaded. `userId` stays in the deps so user-targeted flags are re-evaluated when
    // it becomes available (NEMA-1578).
    dispatch(SetSystemFlags(mapSystemFeatureFlags()));
    // The Playwright readiness signal stays gated on the user id: specs that await it
    // (e.g. `waitForFeatureFlagsReady`) read user-targeted flags and would otherwise
    // race the re-dispatch. Non-Playwright code paths already got the flags above.
    if (userId) {
      signalFeatureFlagsReadyForPlaywright();
    }
  }, [selectedCompanyId, companyId, dispatch, propertyId, rolloutLoaded, userId]);
};

export { useLoadFeatureFlags };
